import { useFinanceMetrics } from '../../state';
import { Loading } from '../loading';

const cellStyle = { padding: '2px 4px', width: '20%' };
const numberStyle = { fontFamily: 'monospace', textAlign: 'right', fontSize: '80%' };

export const Finances = ({ apiKey }) => {
  const finances = useFinanceMetrics(apiKey);

  if (!finances?.metrics || finances?.loading) {
    return <Loading />;
  }

  const rows = Object.keys(finances.metrics).map((date) => {
    const m = finances.metrics[date].metrics;
    const fmt = (n) => '$' + parseFloat(n).toFixed(2);

    const bg = (n) => {
      if (n < m.cost.total * 0.5 || n < 0.5) {
        return {};
      }
      const p = (0.5 * n) / m.cost.total;
      return {
        background: `rgba(255, 59, 48, ${p})`,
      };
    };

    return (
      <tr key={date}>
        <td style={{ ...cellStyle, width: 100 }}>{date}</td>
        <td style={{ ...cellStyle, ...numberStyle, ...bg(m.cost.ai) }}>{fmt(m.cost.ai)}</td>
        <td style={{ ...cellStyle, ...numberStyle, ...bg(m.cost.network) }}>{fmt(m.cost.network)}</td>
        <td style={{ ...cellStyle, ...numberStyle }}>{fmt(m.cost.fetchfox)}</td>
        <td style={{ ...cellStyle, ...numberStyle }}>{fmt(m.cost.total)}</td>
      </tr>
    );
  });

  return (
    <div>
      <table>
        <thead>
          <tr>
            <th style={cellStyle}>Date</th>
            <th style={cellStyle}>AI</th>
            <th style={cellStyle}>Network</th>
            <th style={cellStyle}>FetchFox</th>
            <th style={cellStyle}>Total</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};
